import axios from '../helpers/Axios'

export default {
    async getBookingsDetails() {
        return await axios.get("/BookingsAppointment/getBookingsDetails");
    },
    async getBookingsCalendar(details) {
        return await axios.post("/BookingsAppointment/getBookingsCalendar", details);
    },
    async getBookingsAvailability(details) {
        return await axios.post("/BookingsAppointment/getBookingsAvailability", details);
    },
    async newBookingsAppointment(details) {
        return await axios.post("/BookingsAppointment/newBookingsAppointment", details);
    },
    async getBookingsAppointments(companyId) {
        return await axios.get("/BookingsAppointment/getBookingsAppointments/" + companyId);
    },
    async cancelBookingsAppointment(details) {
        return await axios.post("/BookingsAppointment/cancelBookingsAppointment", details);
    },
}